import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  noPadding?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  noPadding = false
}: SectionProps) {
  return <section id={id} className={`relative w-full overflow-hidden ${noPadding ? '' : 'py-16 md:py-24'} ${className}`} data-id="element-102">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-103">
        {children}
      </motion.div>
    </section>;
}